import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {InfraModule} from 'ac-infra';

@NgModule({
  declarations: [
      LoginComponent
  ],
    imports: [
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        CommonModule,
        InfraModule
    ]
})
export class LoginModule { }
